import { render, staticRenderFns } from "./WebAppUpdated.vue?vue&type=template&id=0567db28"
import script from "./WebAppUpdated.vue?vue&type=script&lang=js"
export * from "./WebAppUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports